var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"dawn-notification"}},[_c('div',{staticClass:"dawn-notification",class:[_vm.type, !_vm.icon ? 'no-icon' : '']},[_c('div',{staticClass:"icon-wrapper",class:{ 'no-icon': !_vm.icon }},[_c('i',{class:_vm.icon})]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",class:{ 'no-icon': !_vm.icon }},[(!_vm.message)?_vm._t("default"):_c('span',[_vm._v(_vm._s(_vm.message))])],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22531eef","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/core/components/edNotice/index.vue
// module id = T7ac
// module chunks = 12